import React from 'react';

import { playSound, Sound } from '~/assets/sounds';
import { StyledInputContainer, StyledInputField } from './RadioButton.styled';

interface RadioButtonProps extends React.HTMLAttributes<HTMLDivElement> {
	name: string;
}

const RadioButton = ({
	id,
	name,
	children,
	defaultChecked,
	onChange,
	onMouseEnter,
	...props
}: RadioButtonProps) => {
	return (
		<StyledInputContainer {...props}>
			<StyledInputField
				id={id}
				name={name}
				onChange={onChange}
				onClick={() => {
					playSound(Sound.ClickButton);
				}}
				onMouseEnter={(e) => {
					onMouseEnter?.(e);
					playSound(Sound.LinkCursor);
				}}
				{...{ defaultChecked }}
			/>
			<label htmlFor={id}>{children}</label>
		</StyledInputContainer>
	);
};

export { RadioButton };
